import { Box, Group, Paper, Skeleton } from '@mantine/core';

import { FullMainHeight } from '@ui';

export function ValidationFormDetailsPageSkeleton() {
  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <Paper>
          <Skeleton height={40} />
        </Paper>
      </FullMainHeight.Header>
      <FullMainHeight.Content>
        <Group h="100%" wrap="nowrap">
          <Box h="100%" style={{ minWidth: 400, maxWidth: 500 }}>
            <Skeleton height="100%" />
          </Box>
          <Skeleton h="100%" w="100%" />
        </Group>
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
}

export default ValidationFormDetailsPageSkeleton;
